import { AxiosProgressEvent } from 'axios';
import { uploadClient } from 'utils/upload/uploadClient';
import { MultipartUploadParams } from 'utils/upload/types';

export async function uploadMultipart(
  blob: Blob,
  params: MultipartUploadParams,
  signal: AbortSignal,
  onProgress?: (loaded: number, total: number) => void
): Promise<void> {
  const { uploadId, partSize, parts } = params;
  const totalSize = blob.size;

  const uploadedParts: { part_number: number; etag: string }[] = [];
  let completedPartsBytes = 0;

  for (const part of parts) {
    const start = (part.partNumber - 1) * partSize;
    const end = Math.min(start + partSize, totalSize);
    const partBlob = blob.slice(start, end);
    const progressOffset = completedPartsBytes;

    // eslint-disable-next-line no-await-in-loop
    const response = await uploadClient.put(part.url, partBlob, {
      signal,
      onUploadProgress: (event: AxiosProgressEvent) => {
        if (event.loaded != null && onProgress) {
          onProgress(progressOffset + event.loaded, totalSize);
        }
      },
    });

    const etag = response.headers.etag as string | undefined;
    if (!etag) {
      throw new Error(`Missing ETag for part ${part.partNumber}`);
    }

    uploadedParts.push({ part_number: part.partNumber, etag });
    completedPartsBytes += partBlob.size;
  }

  await uploadClient.post(
    params.callbackUrl,
    {
      upload_id: uploadId,
      parts: uploadedParts,
      size: totalSize,
    },
    {
      headers: {
        Authorization: `Bearer ${params.callbackToken}`,
        'Content-Type': 'application/json',
      },
      signal,
    }
  );
}
